import { render, staticRenderFns } from "./EmployeeContact.vue?vue&type=template&id=1810f793&"
import script from "./EmployeeContact.vue?vue&type=script&lang=js&"
export * from "./EmployeeContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports